import React from "react";
import { IFAQAutocompleteProps } from "./FAQAutocompleteProps";
import {
  InputWrapper,
  SectionContainer,
  NoSuggestionsDiv,
  SearchResults,
  FAQContainer,
} from "./FAQAutocompleteHelpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import Autosuggest from "react-autosuggest";

const FAQAutocomplete: React.FC<IFAQAutocompleteProps> = (props) => {
  // return null
  const [value, setValue] = React.useState("");
  const [suggestions, setSuggestions] = React.useState([]);

  const isInputBlank = value.trim() === "";
  const [noSuggestions, setNoSuggestions] = React.useState(false);

  const {
    onFAQSelection,
    onFAQSearchRequested,
    id,
    name,
    inputRef,
    placeholder,
  } = props;

  const onAutocompleteChange = (
    _event: any,
    { newValue }: { newValue: any; method: any }
  ) => {
    setValue(newValue);
  };

  const handleSearchFocus = (event: any) => {
    event.target.setSelectionRange(0, event.target.value.length);
  };

  const inputProps = {
    value,
    onChange: onAutocompleteChange,
    onClick: handleSearchFocus,
    className: `rounded form-control `,
    id: id,
    name: name,
    ref: inputRef,
    placeholder: placeholder,
  };

  const renderInputComponent = (inputProps: any) => (
    <InputWrapper>
      <span className="searchIcon" id="search-icon">
        <FontAwesomeIcon icon={faSearch} />
      </span>
      <input aria-label="Search for FAQ" {...inputProps} />
    </InputWrapper>
  );

  const onSuggestionsFetchRequested = ({
    value,
  }: {
    value: string;
    reason: string;
  }) => {
    try {
      const data = onFAQSearchRequested(value);
      setSuggestions(data);

      if (data.length > 0 || isInputBlank) {
        setNoSuggestions(false);
      } else {
        !isInputBlank && value && setNoSuggestions(true);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };

  const renderSuggestionsContainer = ({
    containerProps,
    children,
  }: {
    containerProps: any;
    children: any;
    query: any;
  }) => {
    return (
      <div aria-label="FAQ Search Results" {...containerProps}>
        <SectionContainer>
          <SearchResults>{children}</SearchResults>
        </SectionContainer>
      </div>
    );
  };

  const getSuggestionValue = (suggestion: any) => suggestion.question;

  const renderSuggestion = (suggestion: any) => (
    <span>{suggestion.question}</span>
  );

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
    setNoSuggestions(false);
  };

  const onSuggestionSelected = (_event: any, { suggestion }: any) => {
    onFAQSelection(suggestion);
    setTimeout(() => {
      setNoSuggestions(false);
    }, 100);
  };

  const shouldRenderSuggestions = (value: any) => {
    return value.trim().length > 1;
  };

  return (
    <FAQContainer>
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        onSuggestionSelected={onSuggestionSelected}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        renderSuggestionsContainer={renderSuggestionsContainer}
        renderInputComponent={renderInputComponent}
        highlightFirstSuggestion={true}
        shouldRenderSuggestions={shouldRenderSuggestions}
        inputProps={inputProps}
      />
      {noSuggestions && <NoSuggestionsDiv>No suggestions</NoSuggestionsDiv>}
    </FAQContainer>
  );
};

export default FAQAutocomplete;
